module.exports = __webpack_public_path__ + "img/award03_02.222fd3af.png";